module.exports = __webpack_public_path__ + "assets/img/Fotolia_173659590_XS.d96eae12.jpg";